import { themeColors } from "constants/colors.const";
import { CSSProperties } from "react";

export enum PaywallType {
    map = "map",
    specialOffer = "specialOffer",
    default = "default",
    twoSteps = "twoSteps",
}

const fieldStyles: Record<PaywallType, CSSProperties> = {
    [PaywallType.default]: {
        width: "100%",
        boxSizing: "border-box",
        height: "100%",
        maxHeight: "56px",
        borderRadius: "1rem",
        border: `2px solid ${themeColors.background.whiteOpacity4}`,
        backgroundColor: themeColors.background.secondary,
        color: themeColors.text.white,
        outline: "none",
        fontFamily: "Tahoma, Arial, sans-serif",
        padding: "14px",
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "1",
        letterSpacing: "0.3px",
    },
    [PaywallType.specialOffer]: {
        width: "100%",
        boxSizing: "border-box",
        height: "100%",
        borderRadius: "1rem",
        border: `2px solid ${themeColors.brandColors.brandGreen}`,
        backgroundColor: "transparent",
        color: themeColors.text.black,
        outline: "none",
        fontFamily: "Tahoma, Arial, sans-serif",
        padding: "14px",
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "1",
        letterSpacing: "0.3px",
    },
    [PaywallType.map]: {
        width: "100%",
        boxSizing: "border-box",
        height: "100%",
        WebkitAppearance: "none",
        borderRadius: 0,
        border: "none",
        borderBottom: `1px solid ${themeColors.background.borderLightGrey}`,
        backgroundColor: "transparent",
        color: themeColors.text.white,
        outline: "none",
        fontFamily: "Tahoma, Arial, sans-serif",
        padding: "1rem 0 .5rem",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "1",
        letterSpacing: "2px",
    },
    [PaywallType.twoSteps]: {
        border: `1px solid ${themeColors.background.borderLightGrey}`,
        background: "rgba(45, 49, 55, 0.40)",
        height: "100%",
        borderRadius: "8px",
        padding: "16px",
        color: themeColors.text.white,
        fontSize: "14px",
    },
};

const allFocusStyles = {
    [PaywallType.default]: {
        border: `2px solid ${themeColors.brandColors.brandGreen}`,
    },
    [PaywallType.specialOffer]: {
        border: `2px solid ${themeColors.brandColors.brandGreen}`,
    },
    [PaywallType.map]: {
        borderColor: themeColors.brandColors.brandGreen,
    },
    [PaywallType.twoSteps]: {
        outline: "none",
    },
};

export const getFieldsStyles = (payment: any, paywall?: PaywallType) => {
    let numberFocused = false;
    let cvvFocused = false;

    const getPaywallStyles = (paywall?: PaywallType) => fieldStyles[paywall ?? PaywallType.default];
    const getFocusStyles = (paywall?: PaywallType) => allFocusStyles[paywall ?? PaywallType.default];

    const style = getPaywallStyles(paywall);
    const focusStyle = getFocusStyles(paywall);

    payment.setNumberStyle(style);
    payment.setCvvStyle(style);

    // Focus events
    payment.numberOn("focus", () => {
        numberFocused = true;
        payment.setNumberStyle(focusStyle);
    });
    payment.cvvOn("focus", () => {
        cvvFocused = true;
        payment.setCvvStyle(focusStyle);
    });

    payment.numberOn("blur", () => {
        numberFocused = false;
        payment.setNumberStyle(style);
    });

    payment.cvvOn("blur", () => {
        cvvFocused = false;
        payment.setCvvStyle(style);
    });

    payment.numberOn("mouseout", () => {
        if (!numberFocused) {
            payment.setNumberStyle(style);
        }
    });

    payment.cvvOn("mouseout", () => {
        if (!cvvFocused) {
            payment.setCvvStyle(style);
        }
    });

    return { style, focusStyle };
};
